module.exports = __webpack_public_path__ + "img/21.aa4e1e1a.jpg";